import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { axiosClient } from "$/http"

import Urls from "@/api/urls"

import { QueryKey } from "../constants"

const getCalendarAttrs = async () => {
    const { data } = await axiosClient.get(Urls.coachCalendarAttrs())
    return data
}

export function useCalendarsAttrs() {
    return useQuery<any, AxiosError, any>({
        queryKey: [QueryKey.CalendarAttrs],
        queryFn: getCalendarAttrs,
        refetchOnMount: "always"
    })
}
